const Post12Summary = (lang) => {
	const isRom = lang === 'rom'

	
	return {
		lang,
		cardTitle: isRom?  'Inițiala surpriza' :'The unexpected initial',	
		cardText:  isRom ?  'Acesta este povestea unei inițiale a tatǎlui, diferitǎ decit cea corecta, si adopția prefacuta care a permis familiei tatalui me sa supravietuiasca si sa progreseze in Romania stalinista.': 
		'This is the story behind an unexpected letter in a school record and how my dad\'s side of the family used a pretend adoption to survive and get ahead in Stalinist Romania.', 
		photoPath: '/post12/collage12l.png', 
		photoPathShort: '/post12/collage12s.png', 
		linkId: 'initial'
	}

}

export default Post12Summary;
